import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styled from '@emotion/styled';
import { Text } from '@radix-ui/themes';

const MarkdownWrapper = styled.div`
  > *:first-of-type {
    margin-top: 0;
  }

  > *:last-of-type {
    margin-bottom: 0;
  }

  p {
    margin: 0.5em 0;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 0.75em 0;
    font-size: 13px;
  }

  th,
  td {
    border: 1px solid var(--gray-a5);
    padding: 6px 10px;
    text-align: left;
  }

  th {
    background: var(--gray-a2);
    font-weight: 600;
  }

  tr:nth-of-type(even) {
    background: var(--gray-a1);
  }

  code {
    background: var(--gray-a3);
    border-radius: 4px;
    padding: 1px 4px;
    font-size: 0.9em;
  }

  pre {
    background: var(--gray-a2);
    border-radius: 8px;
    padding: 12px;
    overflow-x: auto;
    margin: 0.75em 0;

    code {
      background: none;
      padding: 0;
    }
  }

  ul,
  ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
  }

  li {
    margin: 0.25em 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1em 0 0.5em;
    line-height: 1.3;
  }

  h1 {
    font-size: 1.4em;
  }
  h2 {
    font-size: 1.2em;
  }
  h3 {
    font-size: 1.1em;
  }

  blockquote {
    border-left: 3px solid var(--accent-8);
    padding-left: 12px;
    margin: 0.75em 0;
    color: var(--gray-11);
  }

  hr {
    border: none;
    border-top: 1px solid var(--gray-a4);
    margin: 1em 0;
  }
`;

interface MarkdownContentProps {
  content: string;
}

export function MarkdownContent({ content }: MarkdownContentProps) {
  return (
    <Text size="2">
      <MarkdownWrapper>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </MarkdownWrapper>
    </Text>
  );
}
